import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { FaFileAudio } from "react-icons/fa";
import { Link } from 'react-router-dom';
import fy24_25a from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/2Qfy25 Investors call.pdf';
import fy24_25b from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/Reschduled Investor Call.pdf';
import fy24_25c from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/Transcript -23.10.2024.pdf';
import fy24_25d from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/Intimation Investor meet.pdf';
import fy24_25e from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/Q3FY25_investor call Invite.pdf';
import fy24_25f from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/10028923.mp3';
import fy24_25g from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2024-25/Transcript 17.01.2025.pdf';
import fy25_26a from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q4 Investor call_09.05.2025.pdf';
import fy25_26b from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/10031927.mp3';
import fy25_26f from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q1FY26- Investor Call.mp3';
import fy25_26c from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q4FY25_Transcript_Investor Call.pdf';
import fy25_26d from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/28.05.2025-Investor meet Invitation.pdf.pdf';
import fy25_26e from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Investor Call_Q1.pdf';
import fy25_26g from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Transcript-SGFinserve-Jul23-2025.pdf';
import fy25_26h from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q2 Earning Conference Call.mp3';
import fy25_26i from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q2FY26_Transcript_Conference Call.pdf';
import fy25_26j from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/10039558.mp3';
import fy25_26k from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/23.01.2026 Transcript Signed.pdf';
import fy25_26l from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q4FY26 Earning Conference Call.mp3';
import fy25_26m from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2025-26/Q4_Transcript_16-04-2026.pdf';
import fy26_27a from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/10044729.mp3';
import fy26_27b from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/Q2_FY2027_Transcript_Conference Call.pdf';
import fy26_27f from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/Q2_FY2027_Transcript_Conference Call_.pdf';
import fy26_27c from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/Q1.pdf';
import fy26_27d from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/Q2.pdf';
import fy26_27e from '../../assests/sgPdf/ScheduleOfAnalyst/FY 2026-27/10047647.mp3';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const ScheduleOfAnalyst = () => {

    const [selectedOption, setSelectedOption] = useState("option0"); // State to track selected option
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show7, setShow7] = useState(false);
    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);
    const [show8, setShow8] = useState(false);
    const handleClose8 = () => setShow8(false);
    const handleShow8 = () => setShow8(true);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    const [show6, setShow6] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const handleClose3 = () => setShow3(false);
    const handleClose4 = () => setShow4(false);
    const handleClose5 = () => setShow5(false);
    const handleClose6 = () => setShow6(false);
    const handleShow1 = () => setShow1(true);
    const handleShow2 = () => setShow2(true);
    const handleShow3 = () => setShow3(true);
    const handleShow4 = () => setShow4(true);
    const handleShow5 = () => setShow5(true);
    const handleShow6 = () => setShow6(true);
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Schedule of Analyst or Institutional Meet </h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>Schedule of Analyst or Institutional Meet </h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option0">FY 2026-2027</option>
                                <option value="option1">FY 2025-2026</option>
                                <option value="option">FY 2024-2025</option>
                                

                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* 24-25 */}
                        {selectedOption === "option0" && (
                            <>
                                
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q1FY27 Earnings Conference Call

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow7}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27b} target='blank'>  <h6>Q1_FY2027_Transcript_Conference Call</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27c} target='blank'>  <h6>Intimation Investor Meet – Q1FY27</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27d} target='blank'>  <h6>Intimation Investor Meet – Q2FY27 & H1FY27</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q2FY27 & H1FY27 Earnings Call Audio

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow8}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26_27f} target='blank'>  <h6>Q2_FY2027_Transcript_Conference Call</h6> </a>
                                </div>
                            </>

                        )}
                        {selectedOption === "option1" && (
                            <>
                                
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26a} target='blank'>  <h6>Q4 Investor call_09.05.2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26c} target='blank'>  <h6>Q4FY25_Transcript_Investor Call</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26d} target='blank'>  <h6>28.05.2025-Investor meet Invitation</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26e} target='blank'>  <h6>Investor Call_Q1</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26g} target='blank'>  <h6>Transcript-SGFinserve-Jul23-2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26i} target='blank'>  <h6>Q2FY26_Transcript_Conference Call</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26k} target='blank'>  <h6>23.01.2026 Transcript Signed</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy25_26m} target='blank'>  <h6>Q4_Transcript_16-04-2026</h6> </a>
                                </div>
                                
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q4FY25 Earning Conference Call_09.05.2025

                                </h6><a class="btn btn-info btncss"  onClick={handleShow2}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q1FY26 Investor Call

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow3}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q2 Earning Conference Call

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow4}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q3FY26 Earning Conference Call

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow5}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q4FY26 Earning Conference Call

                                </h6><a class="btn btn-info btncss1"  onClick={handleShow6}>Play Audio</a>
                                </div>
                               
                                


                            </>

                        )}
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25c} target='blank'>  <h6>Transcript -23.10.2024</h6> </a>
                                </div>
                                
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25a} target='blank'>  <h6>2Qfy25 Investors call</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25b} target='blank'>  <h6>Reschedule of Investor Call</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25d} target='blank'>  <h6>Intimation Investor Meet</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25e} target='blank'>  <h6>Q3FY25_investor call Invite</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy24_25g} target='blank'>  <h6>Transcript 17.01.2025</h6> </a>
                                </div>
                                
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q3FY25 Earning Conference Call as on 17 Jan, 2025

                                </h6><a class="btn btn-info btncss"  onClick={handleShow1}>Play Audio</a>
                                </div>
                                <div className="pdf-clas">
                                    <FaFileAudio size={25} style={{ color: 'red' }} />
                                    <h6>Q1 Earnings Conference Call As On 17 Oct,2024 

                                </h6><a class="btn btn-info btncss"  onClick={handleShow}>Play Audio</a>
                                </div>
                                


                            </>

                        )}
                       



                    </div>
                </div>

            </section>
            <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src="https://sgpdf.s3.ap-south-1.amazonaws.com/sg-pdf/WhatsApp+Audio+2024-10-17+at+5.29.40+PM.mpeg" type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy24_25f} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy25_26b} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show3} onHide={handleClose3}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy25_26f} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show4} onHide={handleClose4}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy25_26h} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show5} onHide={handleClose5}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy25_26j} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show6} onHide={handleClose6}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy25_26l} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show7} onHide={handleClose7}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy26_27a} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      <Modal show={show8} onHide={handleClose8}>
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body>
        <audio class="audioclass" controls>
  <source src={fy26_27e} type="audio/mpeg" />
 
  
</audio></Modal.Body>
        
      </Modal>
      

            <Footer />


        </>
    )
}

export default ScheduleOfAnalyst